var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ModalMantenedor",
    { attrs: { show: _vm.show } },
    [
      _c(
        "CabeceraModal",
        {
          attrs: { titulo: "Crear Requerimiento" },
          on: { cerrar: _vm.handleCerrar }
        },
        [
          _c("NavegacionModalCrud", {
            attrs: { pasos: _vm.pasos },
            on: { guardar: _vm.handleGuardar },
            model: {
              value: _vm.pasoActivoIndex,
              callback: function($$v) {
                _vm.pasoActivoIndex = $$v
              },
              expression: "pasoActivoIndex"
            }
          })
        ],
        1
      ),
      _c(
        "v-card",
        { attrs: { height: "55px", flat: "" } },
        [
          _c(
            "v-bottom-nav",
            {
              attrs: {
                value: true,
                active: _vm.pasos.informacionGeneral.step,
                absolute: "",
                color: "transparent"
              },
              on: {
                "update:active": function($event) {
                  return _vm.$set(_vm.pasos.informacionGeneral, "step", $event)
                }
              }
            },
            [
              _c(
                "v-btn",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.pasos.informacionGeneral.visible,
                      expression: "pasos.informacionGeneral.visible"
                    }
                  ],
                  attrs: {
                    color: "primary",
                    flat: "",
                    value: _vm.pasos.informacionGeneral.step
                  },
                  on: { click: _vm.handleInfoGeneral }
                },
                [
                  _c("span", [_vm._v("Crear Requerimiento")]),
                  _c("v-icon", [_vm._v("add_circle_outline")])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showInfo,
              expression: "showInfo"
            }
          ],
          staticClass: "cardnew",
          attrs: { align: "center" }
        },
        [
          _c("br"),
          _c("v-card", { staticClass: "rounded-card flex sm8 md8" }, [
            _c(
              "div",
              { staticClass: "flex sm10 md10" },
              [
                _c(
                  "v-container",
                  { attrs: { "grid-list-md": "" } },
                  [
                    _c(
                      "FormFieldsContainer",
                      [
                        _c(
                          "v-flex",
                          {
                            attrs: { sm12: "", md12: "", layout: "", wrap: "" }
                          },
                          [
                            _c(
                              "v-flex",
                              {
                                attrs: {
                                  sm12: "",
                                  md12: "",
                                  layout: "",
                                  wrap: ""
                                }
                              },
                              [
                                _c(
                                  "v-flex",
                                  { attrs: { sm4: "", md4: "" } },
                                  [
                                    _c("DatePicker", {
                                      attrs: {
                                        label: _vm.formFields.fecha.label,
                                        "error-messages": _vm.errors.collect(
                                          _vm.formFields.fecha.id
                                        ),
                                        id: _vm.formFields.fecha.id,
                                        readonly: "",
                                        disabled: ""
                                      },
                                      model: {
                                        value: _vm.formFields.fecha.value,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.formFields.fecha,
                                            "value",
                                            $$v
                                          )
                                        },
                                        expression: "formFields.fecha.value"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "v-flex",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: false,
                                        expression: "false"
                                      }
                                    ],
                                    attrs: { sm4: "", md4: "" }
                                  },
                                  [
                                    _c("v-text-field", {
                                      attrs: {
                                        label:
                                          _vm.formFields.requerimiento.label
                                      },
                                      model: {
                                        value:
                                          _vm.formFields.requerimiento.value,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.formFields.requerimiento,
                                            "value",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "formFields.requerimiento.value"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "v-flex",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: false,
                                        expression: "false"
                                      }
                                    ],
                                    attrs: { sm4: "", md4: "" }
                                  },
                                  [
                                    _c("v-text-field", {
                                      attrs: {
                                        label: _vm.formFields.adp.label
                                      },
                                      model: {
                                        value: _vm.formFields.adp.value,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.formFields.adp,
                                            "value",
                                            $$v
                                          )
                                        },
                                        expression: "formFields.adp.value"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "v-flex",
                                  { attrs: { sm4: "", md4: "" } },
                                  [
                                    _c("v-autocomplete", {
                                      attrs: {
                                        label: _vm.formFields.rutCliente.label,
                                        items: _vm.listaClientes,
                                        "item-text": "nombre",
                                        "item-value": "id"
                                      },
                                      on: { change: _vm.getFlotas },
                                      model: {
                                        value: _vm.formFields.rutCliente.value,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.formFields.rutCliente,
                                            "value",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "formFields.rutCliente.value"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "v-flex",
                                  { attrs: { sm4: "", md4: "" } },
                                  [
                                    _c("v-autocomplete", {
                                      attrs: {
                                        label: _vm.formFields.flota.label,
                                        items: _vm.listaFlotas,
                                        "item-text": "nombre",
                                        "item-value": "id"
                                      },
                                      model: {
                                        value: _vm.formFields.flota.value,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.formFields.flota,
                                            "value",
                                            $$v
                                          )
                                        },
                                        expression: "formFields.flota.value"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "v-flex",
                                  { attrs: { sm4: "", md4: "" } },
                                  [
                                    _c("v-autocomplete", {
                                      attrs: {
                                        label:
                                          _vm.formFields.serieactivamodalidad
                                            .label,
                                        items: _vm.listaModalidad,
                                        "item-text": "nombre",
                                        "item-value": "id"
                                      },
                                      model: {
                                        value:
                                          _vm.formFields.serieactivamodalidad
                                            .value,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.formFields.serieactivamodalidad,
                                            "value",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "formFields.serieactivamodalidad.value"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "v-flex",
                                  { attrs: { sm4: "", md4: "" } },
                                  [
                                    _c("v-text-field", {
                                      attrs: { label: _vm.formFields.oc.label },
                                      model: {
                                        value: _vm.formFields.oc.value,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.formFields.oc,
                                            "value",
                                            $$v
                                          )
                                        },
                                        expression: "formFields.oc.value"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "v-flex",
                                  { attrs: { sm4: "", md4: "" } },
                                  [
                                    _c("v-autocomplete", {
                                      attrs: {
                                        label: _vm.formFields.mandante.label,
                                        items: _vm.listaClientes,
                                        "item-text": "nombre",
                                        "item-value": "id"
                                      },
                                      model: {
                                        value: _vm.formFields.mandante.value,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.formFields.mandante,
                                            "value",
                                            $$v
                                          )
                                        },
                                        expression: "formFields.mandante.value"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "v-flex",
                                  { attrs: { sm12: "" } },
                                  [
                                    _c("v-textarea", {
                                      attrs: {
                                        label: _vm.formFields.asignota.label
                                      },
                                      model: {
                                        value: _vm.formFields.asignota.value,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.formFields.asignota,
                                            "value",
                                            $$v
                                          )
                                        },
                                        expression: "formFields.asignota.value"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _c(
                              "v-flex",
                              {
                                attrs: {
                                  xs12: "",
                                  sm12: "",
                                  md12: "",
                                  layout: ""
                                }
                              },
                              [
                                _c(
                                  "v-flex",
                                  [
                                    _c(
                                      "v-flex",
                                      {
                                        attrs: { xs12: "", sm12: "", md12: "" }
                                      },
                                      [
                                        _c(
                                          "v-btn",
                                          {
                                            staticClass: "btnPlantilla",
                                            attrs: {
                                              flat: "",
                                              small: "",
                                              color: "primary"
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.descargarPlantilla()
                                              }
                                            }
                                          },
                                          [
                                            _c(
                                              "v-icon",
                                              {
                                                staticClass:
                                                  "importExportBtnIcon"
                                              },
                                              [_vm._v("cloud_download")]
                                            ),
                                            _vm._v(
                                              "  \n                      "
                                            ),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "importExportBtnTexto"
                                              },
                                              [_vm._v("Descargar Plantilla")]
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-flex",
                                      {
                                        attrs: {
                                          xs12: "",
                                          sm12: "",
                                          md12: "",
                                          layout: ""
                                        }
                                      },
                                      [
                                        _c("p", { staticClass: "aclaracion" }, [
                                          _vm._v(
                                            "\n                      Utilice el formato de la siguiente plantilla para evitar\n                      conflictos al momento de cargar la solicitud.\n                    "
                                          )
                                        ])
                                      ]
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  { staticClass: "flex xs6 sm6 md6" },
                                  [
                                    _c("v-text-field", {
                                      attrs: {
                                        xs3: "",
                                        sm3: "",
                                        md3: "",
                                        label:
                                          "Seleccione Archivo para carga masiva",
                                        heigh: "",
                                        "error-messages": _vm.errors.collect(
                                          "archivo"
                                        ),
                                        "data-vv-name": "archivo",
                                        readonly: "readonly"
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.$refs.image.click()
                                        }
                                      },
                                      model: {
                                        value: _vm.fileName,
                                        callback: function($$v) {
                                          _vm.fileName = $$v
                                        },
                                        expression: "fileName"
                                      }
                                    }),
                                    _c("input", {
                                      ref: "image",
                                      staticStyle: { display: "none" },
                                      attrs: {
                                        type: "file",
                                        accept: ".xlsx, .xls",
                                        clearable: "",
                                        id: "archivoExcel"
                                      },
                                      on: { change: _vm.prepare_file_upload }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  { staticClass: "flex xs2 sm2 md2" },
                                  [
                                    _c(
                                      "v-btn",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: _vm.fileName,
                                            expression: "fileName"
                                          }
                                        ],
                                        staticStyle: { "margin-top": "10px" },
                                        on: { click: _vm.quitarRegistro }
                                      },
                                      [_vm._v("✖")]
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  { staticClass: "flex xs2 sm2 md2" },
                                  [
                                    false
                                      ? _c(
                                          "v-btn",
                                          {
                                            staticClass:
                                              "btn-sucursal btn-cargar v-btn theme--light",
                                            staticStyle: {
                                              "margin-top": "10px"
                                            },
                                            attrs: {
                                              disabled: _vm.errorArchivo
                                            },
                                            on: { click: _vm.cargar }
                                          },
                                          [
                                            _c("v-icon", [
                                              _vm._v("attach_file")
                                            ]),
                                            _vm._v("Cargar\n                  ")
                                          ],
                                          1
                                        )
                                      : _vm._e()
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c("div", { staticClass: "grid-container" }, [
                      _c("div", { staticClass: "fake-vertical-scrollbar" }),
                      _c(
                        "div",
                        {
                          ref: "gridContainerRef",
                          staticClass: "series-stock"
                        },
                        [
                          _c("MantenedorGridSinCodigo", {
                            attrs: {
                              "funcionalidad-id": _vm.funcionalidad,
                              "grid-options": _vm.gridOptions
                            }
                          })
                        ],
                        1
                      )
                    ])
                  ],
                  1
                )
              ],
              1
            )
          ])
        ],
        1
      ),
      _c("Confirmation", {
        attrs: {
          show: _vm.dialogConfirmacionGuardar,
          titulo: _vm.$t("mensajes.crud.crear.titulo", {
            entidad: "Requerimiento"
          }),
          mensaje: _vm.mensajeConfirmacion,
          textoBtnSi: _vm.$t("mensajes.crud.crear.btnAceptar"),
          textoBtnNo: _vm.$t("mensajes.crud.crear.btnCancelar")
        },
        on: {
          modalConfirmationEmit: function($event) {
            return _vm.handleConfirmacionGuardar($event)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }